import PoseModel from './src/PoseModel.vue'

PoseModel.install = function(Vue) {
    Vue.component(PoseModel.name, PoseModel)
}

export default PoseModel